function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}

function setCookie(name, value, days) {
  const d = new Date();
  d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
  let expires = "expires=" + d.toUTCString();
  document.cookie = name + "=" + value + ";" + expires + ";path=/";
}

function addProductToRecentlyViewed(productHandle) {
  let recentlyViewed = getCookie('recently_viewed') ? JSON.parse(getCookie('recently_viewed')) : [];

  if (!recentlyViewed.includes(productHandle)) {
    recentlyViewed.push(productHandle);
  }

  if (recentlyViewed.length > 4) {
    recentlyViewed.shift();
  }

  setCookie('recently_viewed', JSON.stringify(recentlyViewed), 30);
}

function displayRecentlyViewed() {
  const recentlyViewed = getCookie('recently_viewed') ? JSON.parse(getCookie('recently_viewed')) : [];
  const activeLanguage = (typeof Shopify !== 'undefined' && Shopify.locale) || 'en';
  const section = document.querySelector('.recently-viewed__section');

  if (recentlyViewed.length > 0) {
    section.style.display = 'block';
    const container = document.querySelector('.recently-viewed__container .recently-viewed__list-container');
    const dataLayerValue = container?.getAttribute('data-layer');
    container.innerHTML = '';

    recentlyViewed.forEach(handle => {
      fetch(`/products/${handle}.js`)
        .then(response => response.json())
        .then(product => {
          const soldOut = !product.variants.some(variant => variant.available);
          const firstVariant = product.variants[0];

          const mediaHTML = product.images.slice(0, 2).map((image, index) => `
            <div class="media__container product-tile__gallery-media-${index + 1}">
              ${dataLayerValue ? `
                <div
                  class="product-tile__gallery-layer"
                  style="background: ${dataLayerValue};">
                </div>
              ` : ''}
              <img
                src="${image}"
                alt="${product.title}"
                class="product-tile__gallery-media-${index + 1}"
              />
            </div>
          `).join('');

          const tagHTML = product.tags.map(tag => {
            if (tag.startsWith('label_')) {
              const processedTag = tag.replace('label_', '');
              const pairs = processedTag.split('|');
              for (const pair of pairs) {
                const parts = pair.split('-');
                if (parts[0] === activeLanguage) {
                  return `<div class="product-tile__tags-label">${parts[1].toUpperCase()}</div>`;
                }
              }
            }
            return '';
          }).find(Boolean) || '';

          const productHTML = `
            <div class="product-tile__container">
              <a href="${product.url}" class="product-tile__gallery">
                ${mediaHTML}
                <div class="product-tile__tags">
                  ${tagHTML}
                </div>
              </a>
              <div class="product-tile__info">
                ${product.vendor ? `<p class="product-tile__vendor">${product.vendor}</p>` : ''}
                <a href="${product.url}" class="product-tile__title">
                  <p>${product.title}</p>
                </a>
                ${
                  !soldOut
                    ? `
                      <div class="product-tile__price">
                        ${firstVariant.compare_at_price ? `<del>${(firstVariant.compare_at_price / 100).toFixed(2)}</del>` : ''}
                        <span>${(firstVariant.price / 100).toFixed(2)}</span>
                      </div>
                    `
                    : '<div class="product-tile__sold-out">Sold Out</div>'
                }
              </div>
            </div>
          `;
          container.insertAdjacentHTML('beforeend', productHTML);
        });
    });
  } else {
    section.style.display = 'none';
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const productContainer = document.querySelector('.product-page__section');
  if (productContainer) {
    const url = window.location.pathname;
    const productHandle = url.split('/').pop();

    if (productHandle) {
      addProductToRecentlyViewed(productHandle);
    }
  }

  displayRecentlyViewed();
});
